import _ from 'lodash';
import { createSelector } from 'reselect';
import timm from 'timm';

import CadminApi        from 'app/apis/company-admin';
import reducerUtils     from 'app/reducers/utils';
import CadminSlx        from 'app/selectors/company-admin/';
import EntitiesSlx      from 'app/selectors/entities';
import ToastAx          from 'app/actions/toast';

import formsHelpers from 'app/helpers/forms';
import paths from 'app/paths';
import history from 'app/history';



/*
 *  Actions
 */

const Types = {
  LOAD_ALL: 'CA_FORMS_LOAD_ALL',
  CREATE: 'CA_FORMS_CREATE',
  UPDATE: 'CA_FORMS_UPDATE',
  SAVE: 'CA_FORMS_SAVE',
  SET_BLDR_FORM: 'CA_FORMS_SET_BLDR_FORM',
};

const Ax = {

  loadAll: (companyId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.formsLoadAll(companyId);
    return dispatch({type: Types.LOAD_ALL, promise, _entities: ['forms']});
  },

  create: (companyId, attrs) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.formsCreate(companyId, attrs);
    return dispatch({type: Types.CREATE, promise, _entities: ['form']});
  },

  update: (companyId, formId, attrs) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.formsUpdate(companyId, formId, attrs);
    return dispatch({type: Types.UPDATE, promise, _entities: ['form']});
  },

  save: (form, attrs, {redirect=false} = {}) => (dispatch, getState) => {
    const company = CadminSlx.company(getState());
    const isNew = formsHelpers.isNew(form);
    const action = isNew ? Ax.create(company.id, attrs) : Ax.update(company.id, form.id, attrs);
    const promise = dispatch(action);
    promise.then(() => {
      // TODO: currently assuming all forms are for grants
      if (!redirect) return;
      const isShared = !attrs.ownerId;
      const thing = isShared ? 'Shared form' : 'Form';
      const msg = isNew ? `${thing} created.` : `${thing} updated.`;
      dispatch(ToastAx.success(msg));
      const path = isShared ? paths.cadminGrantSysSettings(company.slug, 'forms') : paths.cadminGrantProgram(company.slug, attrs.ownerId, {tab: 'config'});
      history.push(path);
    });
    return dispatch({type: Types.SAVE, promise});
  },

  setBldrForm: (form) => {
    const result = {bldrForm: form};
    return {type: Types.SET_BLDR_FORM, _entities: ['bldrForm'], result};
  },

};



/*
 *  Reducer
 */

const initialState = {
  formIds: null,
  bldrSavePending: false,
};

const reducer = reducerUtils.createReducer(initialState, {

  [`${Types.LOAD_ALL}_PENDING`]: (state, action) => {
    return {...state,
      formIds: [],
    };
  },
  [`${Types.LOAD_ALL}_RESOLVED`]: (state, action) => {
    const formIds = action.result.forms.map(f => f.id);
    return {...state,
      formIds,
    };
  },

  [`${Types.SAVE}_PENDING`]: (state, action) => {
    return {...state,
      bldrSavePending: true,
    };
  },
  [`${Types.SAVE}_RESOLVED`]: (state, action) => {
    return {...state,
      bldrSavePending: false,
    };
  },
  [`${Types.SAVE}_REJECTED`]: (state, action) => {
    return {...state,
      bldrSavePending: false,
    };
  },

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selFormIds = (state) => state.companyAdmin.forms.formIds;
  const selBldrSavePending = (state) => state.companyAdmin.forms.bldrSavePending;

  const selAllForms = createSelector(
    [selFormIds, EntitiesSlx.forms],
    (ids, formMap) => {
      if (!ids) return null;
      return ids.map(id => formMap[id]).filter(f => f);
    }
  );

  const selSharedForms = createSelector(
    [selAllForms],
    (allForms) => {
      if (!allForms) return null;
      return allForms.filter(f => !f.ownerId);
    }
  );

  return {
    allForms: selAllForms,
    sharedForms: selSharedForms,
    bldrSavePending: selBldrSavePending,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
